import { fetchActInfo, fetchActs } from "@/api/profile";

export default {
  namespaced: true,
  state: {
    acts: [],
    actInfo: {},
    hasError: {},
  },

  mutations: {
    SET_ACT_DATA(state, payload) {
      state.acts = payload;
    },
    SET_ACT_INFO(state, payload) {
      state.actInfo = payload;
    },
    SET_ERROR(state, status) {
      state.hasError = status;
    },
  },

  actions: {
    async loadActs({ commit }, childId) {
      // if (state.acts.length > 0) return;
      try {
        const response = await fetchActs(childId);
        commit("SET_ACT_DATA", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    },
    async loadActInfo({ commit }, payload) {
      // if (state.actInfo.length > 0) return;
      try {
        const response = await fetchActInfo(payload);
        commit("SET_ACT_INFO", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        throw error;
      }
    },
  },

  getters: {
    acts: (state) => state.acts,
    actInfo: (state) => state.actInfo,
  },
};
